<template>
  <div class="refundable-items-view">
    <el-card
        style="margin: 0px;"
        class="item-card"
        :class="{ 'highlighted-item-card': isSelected }">
      <div class="item-info-row flex-auto">
        <img
            v-if="images && images.length && images[0].src"
            class="item-image"
            :alt="images[0].alt"
            :src="images[0].src">
        <div
            style="margin-left: 8px"
            class="flex-auto">
          <div class="flex flex-row">
            <div class="item-name flex-1">
              {{ title }}
            </div>
          </div>
          <div class="item-sku">
            ASIN: &nbsp;{{ sku }}
          </div>
        </div>
        <ItemRefundReasons
            v-if="isSelected || selectedReason"
            :refund-reasons="refundReasons"
            :selected-reason="selectedReason"
            @selected-reason="setSelectedReason" />
        <el-checkbox
            :value="isSelected"
            style="margin-right: 16px"
            @change="toggleSelection" />
      </div>
      <div class="item-refund-row">
        <ItemRefundAmountInput
            v-if="isSelected || selectedReason"
            :stripe-order-item="stripe_order_item"
            :initial-refund-amount="refundAmount"
            :initial-refund-type="refundType"
            @refund-amount-update="handleRefundAmountUpdate" />
      </div>
    </el-card>
  </div>
</template>

<script>
import ItemRefundAmountInput from "./ItemRefundAmountInput.vue";
import ItemRefundReasons from "./ItemRefundReasons.vue";

export default {
  name: "RefundableOrderItemView",
  components: { ItemRefundReasons, ItemRefundAmountInput },
  props: {
    id: {
      type: Number,
      default() {
        return 0;
      },
    },
    title: {
      type: String,
      default() {
        return "N/A";
      },
    },
    sku: {
      type: String,
      default() {
        return "N/A";
      },
    },
    images: {
      type: Array,
      default: () => {
        return [];
      },
    },
    refundReasons: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    selectedReason: {
      type: Number,
      default: null,
    },
    refundAmount: {
      type: Number,
      default: 0,
    },
    refundType: {
      type: String,
      default: "partial",
    },
    stripe_order_item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    devicePicture() {
      return this.images[0];
    },
  },
  methods: {
    toggleSelection(value) {
      this.$emit("update:selected", value);
      this.$emit("update:reason", null);
    },
    setSelectedReason(value) {
      this.$emit("update:reason", value);
    },
    handleRefundAmountUpdate({ isValid, refundAmount, refundType }) {
      this.$emit("update:isValidRefund", isValid);
      this.$emit("update:refundAmount", refundAmount);
      this.$emit("update:refundType", refundType);
    },
  },
};
</script>

<style scoped>
.refundable-items-view {
  .item-card {
    padding: 8px;
    margin-right: 0px !important;
    min-height: 80px;
    box-shadow: none !important;

    .item-info-row {
      display: flex;
    }
    .item-refund-row {
      align-self: end;
    }
  }
  .item-image {
    height: 80px;
    width: 80px;
  }
  .highlighted-item-card {
    background: #eff8fc;
    border: 2px solid #1998d5;
    border-radius: 4px;
  }
  .item-name {
    height: 24px;
    font-family: "Equip", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #424242;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 15px;
  }
  .item-sku {
    height: 24px;
    font-family: "Equip", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 2px;
  }
}
</style>
